import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { LoggerService } from '../logging/logger.service';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  // Local dev bypass — skip Entra entirely
  if (environment.bypassAuth) {
    if (!auth.isAuthenticated()) {
      auth.initLocalBypass();
    }
    if (!auth.isAdmin() && route.routeConfig?.path !== 'viewreports') {
      logger.warn('AuthGuardNonAdminRedirect', { userId: auth.currentUser()?.sub });
      return router.createUrlTree(['/viewreports']);
    }
    return true;
  }

  // Angular runs app initializers concurrently, so the router's initial navigation
  // can reach this guard while initializeAuth() is still exchanging the `?code=`.
  // Redirecting now would cancel that in-flight POST and loop back to Entra forever.
  await auth.whenReady();

  if (!auth.isAuthenticated()) {
    if (auth.loginFailed()) {
      logger.warn('AuthGuardLoginFailed', { path: route.routeConfig?.path });
      return router.createUrlTree(['/autherror']);
    }
    logger.warn('AuthGuardRedirect', { path: route.routeConfig?.path });
    await auth.initiateLogin();
    return false;
  }

  if (!auth.isAdmin() && route.routeConfig?.path !== 'viewreports') {
    logger.warn('AuthGuardNonAdminRedirect', { userId: auth.currentUser()?.sub });
    return router.createUrlTree(['/viewreports']);
  }

  return true;
};
